export default "<p>{{ data.text }}</p>\n<mat-dialog-actions>\n    <button mat-button (click)=\"onOkClick()\">Ok</button>\n</mat-dialog-actions>"